import React from "react";

import { WizardPage } from "./WizardPage";

export const SingleWizardPage = (props) => (
  <WizardPage {...props} isSingle={true} />
);
